// Environment configuration with robust fallbacks
// This handles cases where Next.js static export mode doesn't load env vars properly

interface EnvironmentConfig {
  apiBaseUrl: string;
  isDevelopment: boolean;
  isProduction: boolean;
}

const getEnvironmentConfig = (): EnvironmentConfig => {
  // Check if we're in browser or server
  const isBrowser = typeof window !== 'undefined';

  // Get environment variables with fallbacks
  const apiServerBaseUrl = process.env.NEXT_PUBLIC_APISERVER_BASE_URL;
  const nodeEnv = process.env.NODE_ENV;

  console.log('Environment Config Debug:', {
    isBrowser,
    apiServerBaseUrl,
    nodeEnv,
    processEnvKeys: Object.keys(process.env).filter(key => key.startsWith('NEXT_PUBLIC_'))
  });
  
  // Determine API base URL with multiple fallback strategies
  let apiBaseUrl: string;
  
  if (apiServerBaseUrl && apiServerBaseUrl !== 'undefined' && apiServerBaseUrl.trim() !== '') {
    apiBaseUrl = apiServerBaseUrl;
    console.log('✅ Using environment variable for API URL:', apiBaseUrl);
  } else {
    // Fallback based on environment
    if (nodeEnv === 'production') {
      // In production, try to detect the current domain
      if (isBrowser) {
        const protocol = window.location.protocol;
        const hostname = window.location.hostname;
        apiBaseUrl = `${protocol}//${hostname}`;
        console.log('🔄 Production fallback - using current domain:', apiBaseUrl);
      } else {
        apiBaseUrl = 'https://smartmatrix.azurewebsites.net'; // Production fallback
        console.log('🔄 Production fallback - using default production URL:', apiBaseUrl);
      }
    } else {
      // Development fallback
      apiBaseUrl = 'https://localhost:5001';
      console.log('🔄 Development fallback - using localhost HTTPS:', apiBaseUrl);
    }
  }
  
  return {
    apiBaseUrl: apiBaseUrl,
    isDevelopment: nodeEnv === 'development',
    isProduction: nodeEnv === 'production'
  };
};

// Export the configuration
export const environmentConfig = getEnvironmentConfig();

// Export individual values for convenience
export const API_BASE_URL = environmentConfig.apiBaseUrl;
export const IS_DEVELOPMENT = environmentConfig.isDevelopment;
export const IS_PRODUCTION = environmentConfig.isProduction;

console.log('🚀 Final Environment Configuration:', environmentConfig);